import { render } from "./Assets.vue?vue&type=template&id=3a339adf"
import script from "./Assets.vue?vue&type=script&lang=ts"
export * from "./Assets.vue?vue&type=script&lang=ts"
script.render = render

export default script